jQuery(document).ready(function () {
  jQuery('html').attr('role','application');
  //25. Inappropriate heading structure
  jQuery('h3.section-header__title').replaceWith(function () {
        return jQuery("<h2>", {
         class: this.className,
         html: jQuery(this).html(),
         style: jQuery(this).attr('style')
       });
    });

  //26. Empty "alt" attribute provided for image link
  
  jQuery(".rte__image img").attr("alt", "Bloom gives back - small business, big impact");

  //13. Informative images missing alt text
  jQuery(".logo-bar__item:eq(0) img").attr("alt","E News logo");
  jQuery(".logo-bar__item:eq(1) img").attr("alt","BuzzFeed logo");
  jQuery(".logo-bar__item:eq(2) img").attr("alt","Stationery trends logo");
  jQuery(".logo-bar__item:eq(3) img").attr("alt","Business Inisder logo");
  jQuery(".logo-bar__item:eq(4) img").attr("alt","Good housekeeping logo");
  jQuery(".logo-bar__item:eq(5) img").attr("alt","USA Today logo");
  jQuery(".logo-bar__item:eq(6) img").attr("alt","MSNBC logo");

  // 17. Unclear functionality of carousel controls
  jQuery('.product-single__sticky').attr({
      "role": "region",
      "aria-label": "Carousel"
  });
  jQuery('.product-single__sticky .product__thumb-arrow--prev').attr('aria-label','Previous');
  jQuery('.product-single__sticky .product__thumb-arrow--next').attr('aria-label','Next');

  var count_slide=1;
  jQuery(".product-single__sticky .product-main-slide img").each(function() {
    var alt_name_slide = jQuery(this).attr('alt');
    jQuery(this).attr('alt', alt_name_slide +' - View '+ count_slide);
    count_slide++;
  });
  var count=1;
  jQuery(".product-single__sticky .product__thumb-item img").each(function() {
    var alt_name = jQuery(this).attr('alt');
    jQuery(this).attr('alt', alt_name +' - View '+ count);
    count++;
  });
  // 17. Unclear functionality of carousel controls

  jQuery('details').attr('aria-expanded','false');
  jQuery('summary').removeAttr('aria-expanded');
  jQuery("html").on("click", function(e){
      jQuery('summary').removeAttr('aria-expanded');
  });
  jQuery('ul.site-navigation').on("keydown", "li.site-nav--has-dropdown:not(.focused)",function(e) {
    if(e.keyCode == 13) {
        jQuery('ul.site-navigation').find("li.site-nav--has-dropdown.focused").removeClass("focused")
        jQuery('ul.site-navigation').find("li.site-nav--has-dropdown").find(".site-nav__details").removeAttr('open');          
        e.preventDefault();
        jQuery(this).addClass("focused");
        jQuery(this).children(":first").attr("aria-expanded","true");
        jQuery(this).find(".site-nav__details").attr('open','');
      }
    });

  jQuery(document).on('focusin', 'li.site-nav--has-dropdown summary.site-nav__link', function(event){
      jQuery("li.site-nav--has-dropdown").find(".site-nav__details").removeAttr('open');
      jQuery("li.site-nav--has-dropdown").removeClass("focused");
      jQuery("li.site-nav--has-dropdown").children(":first").attr("aria-expanded", "false");
      jQuery('summary').removeAttr('aria-expanded');
    });
  jQuery('body').on("keydown", "ul.site-navigation li.site-nav--has-dropdown:last a.site-nav__dropdown-link:last",function(e) {
      if(e.keyCode == 9){
        jQuery("li.site-nav--has-dropdown").find(".site-nav__details").removeAttr('open');
        jQuery("li.site-nav--has-dropdown").removeClass("focused");
        jQuery("li.site-nav--has-dropdown").children(":first").attr("aria-expanded", "false");
        jQuery('summary').removeAttr('aria-expanded');
      }
    });
   jQuery("li.site-nav--has-dropdown").on('mouseout',function(){
       jQuery(this).removeClass("focused")
    });

  jQuery("ul.site-navigation").on("keyup", "li.site-nav__item", function(e){
      if(e.keyCode == 9){
        jQuery("li.site-nav__expanded-item").not(this).removeClass("focused");
        jQuery("li.site-nav__expanded-item").not(this).children(":first").attr("aria-expanded", "false");
        jQuery('summary').removeAttr('aria-expanded');
        jQuery("li.site-nav__expanded-item").not(this).find(".site-nav__details").removeAttr('open');
        e.preventDefault();
      } 
  });
  jQuery("html").on("keydown", "ul.site-navigation li.site-nav__item", function(e){
     if(e.keyCode === 27) {
          setTimeout(()=>{
            jQuery(this).closest('li.site-nav--has-dropdown').find('summary').focus();
            jQuery(this).closest('li.site-nav--has-dropdown').removeClass("focused");
            jQuery(this).closest('li.site-nav--has-dropdown').children(":first").attr("aria-expanded","false");
            jQuery('summary').removeAttr('aria-expanded');
            jQuery(this).find(".site-nav__details").removeAttr('open');
          }, 100)
      }
    });
  // 5 and 6 Error messages difficult to locate
  var error_content = jQuery('#newsletter-footer .errors ul li').html();
  jQuery('#newsletter-footer .errors').text(error_content);
  jQuery("#newsletter-footer .errors, #newsletter-footer .note--success, .note--success").attr("role","alert");

 
   setTimeout(()=>{
      var collection_error_content = jQuery('.collapsibles-wrapper .errors ul li').html();
      jQuery('.collapsibles-wrapper .errors').replaceWith(function () {       
            return jQuery("<p>", {
             class: this.className,
             html: collection_error_content
           });
        });
      // 18 and 20 Error messages difficult to locate
       jQuery(".collapsibles-wrapper .errors").attr("id","email-error");
       var email_error_id = jQuery(".collapsibles-wrapper .errors").attr("id");
       jQuery('.contact-form').find('input[type=email]').attr("aria-describedby", email_error_id);
    }, 500)

    //24. Missing "alt" attribute for image links
  setTimeout(()=>{
    jQuery(".product-block .image a").attr("aria-hidden","true");
    jQuery(".product-block .image img").attr("alt","");
    jQuery(".product-block .image a").attr("tabindex","-1");

    var i = 1;
    var j = 2;
    jQuery("#launchtip_upsell_wrapper .productbox").each(function () {   
      jQuery(this).find("a.detail_title").attr("id", "addthis"+i);
      jQuery(this).find("button.add-to-cart").attr("id", "addthis"+j);
      jQuery(this).find("button.add-to-cart").attr('aria-labelledby', 'addthis'+ j +' addthis'+ i);
      i+=2;
      j+=2;
    }) 
  }, 12000)

  
})
